var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTanzania(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_8632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 20.4853C4.0181 20.9887 4.55519 21.4376 5.11858 21.8329L21.8328 5.1186C21.4376 4.55521 20.9887 4.01811 20.4853 3.51472C19.9818 3.01133 19.4448 2.56246 18.8814 2.16721L2.16724 18.8815C2.56239 19.4447 3.01136 19.9819 3.51471 20.4853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51471 3.51469C-0.271007 7.3005 -0.997804 12.986 1.33296 17.5021L17.5021 1.33298C12.986 -0.997783 7.30048 -0.27094 3.51471 3.51469Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4853 20.4853C24.271 16.6996 24.9978 11.014 22.6671 6.49789L6.49792 22.667C11.0139 24.9978 16.6995 24.271 20.4853 20.4853Z",
    fill: "#338AF3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_8632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanzania);
export default __webpack_public_path__ + "static/media/tanzania.7e0a5b393d5e90655bbc25efd6831837.svg";
export { ForwardRef as ReactComponent };